import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-equipment-size-form',
    templateUrl: './equipment-size-form.component.html',
    styleUrls: ['./equipment-size-form.component.less'],
    standalone: false
})
export class EquipmentSizeFormComponent implements OnInit {

  equipmentSizeForm: FormGroup;
  sizes: number[] = [20,40,45];
  noOfTeus: string[] = ['1', '2'];
  isEditedData:boolean=false;
  yesNoList=this.utilityService.getYesNoList();
  editPermission:boolean=false;
  addPermission:boolean=false;

  constructor(private formBuilder: FormBuilder, 
              @Inject(MAT_DIALOG_DATA) public data: any,
              private service:DataService,
              private utilityService: UtilityService,
              private dailog:MatDialog,
              private logger:NGXLogger,
              private router:Router,
              private dailogRef : MatDialogRef<EquipmentSizeFormComponent>,
              private permissionService:PermissionService)
              { this.dailogRef.disableClose=true;}

ngOnInit(): void {
  this.checkAllPermissions();
  this.initializeEquipmentSizeForm();
  this.setSizeValueChangeEvent();
  this.patchValue();
}

private initializeEquipmentSizeForm(){
  this.equipmentSizeForm = this.formBuilder.group({
    id:[],
    size:[null,[Validators.required]],
    noOfTeu:[null,[Validators.required,]]
  });
}

setSizeValueChangeEvent(){
  this.size.valueChanges.subscribe(sizeValue => {
      this.noOfTeu.reset();
      if(sizeValue==40 || sizeValue==45){
        this.noOfTeu.setValue("2");
      }
      if(sizeValue==20){
        this.noOfTeu.setValue("1");
      }
  })
}


private patchValue() {
  if (this.data?.id) {
    this.equipmentSizeForm.patchValue(this.data);
  }
}

public save() {  
  this.equipmentSizeForm.markAllAsTouched();
    if(this.equipmentSizeForm.valid)
    {
      this.isEditedData=true;
      if(this.id.value){
      this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
    }
    else {
      this.openDailog(Message.SAVE_OPEN_DAILOG);
    }  
  }
}

saveEquipmentSizeModule(){
  this.equipmentSizeForm.markAllAsTouched();
  let method=(this.id.value) ? 'put' : 'post';
  let message=(this.id.value) ? 'updated' : 'saved';
  if(this.equipmentSizeForm.valid){
    this.equipmentSizeForm.markAsUntouched();
    this.service[method](Api.EQUIPMENT_SIZE, this.equipmentSizeForm.value).subscribe(res => {
    this.utilityService.notifier('equipment size Details '+message+' successfully', 'success');
    this.router.navigate([APP_ROUTES.EQUIPMENT_SIZE]);
    this.dailogRef.close();
    });
  }
}

cancel() 
{
  if(this.equipmentSizeForm.dirty && !this.equipmentSizeForm.untouched){
    this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT);
  }
  else{
    this.router.navigate([APP_ROUTES.EQUIPMENT_SIZE]);
    this.dailogRef.close();
  }
}

private openDailog(message?:string){
  const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
      data:message,
      maxWidth:"300px",
      maxHeight:"150px"
    });

  dailogRef.afterClosed().subscribe(dailogResult => {
      if(dailogResult===false){
        return;
      }
      else {
        if(!this.isEditedData) {
          this.router.navigate([APP_ROUTES.EQUIPMENT_SIZE]);
          this.dailogRef.close();
        }
        else{
          this.saveEquipmentSizeModule();
        }
      }
  })
}
   
public checkAllPermissions(){
  let permissionCodes=[PermissionKey.EQUIPMENT_SIZE_MODULE_ADD_PERMISSION,PermissionKey.EQUIPMENT_SIZE_MODULE_EDIT_PERMISSION];
  let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.EQUIPMENT_SIZE_MODULE);
  this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EQUIPMENT_SIZE_MODULE_EDIT_PERMISSION})?.show?true:false;
  this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EQUIPMENT_SIZE_MODULE_ADD_PERMISSION})?.show?true:false;
}
  
  get id(){return this.equipmentSizeForm.get('id')};
  get size(){return this.equipmentSizeForm.get('size')};
  get noOfTeu(){ return this.equipmentSizeForm.get('noOfTeu')};

}
